// Pure helpers for the PompaBooking embed (NTAI-EMB-03). Kept free of React and the
// DOM so the behaviour the embed depends on is unit-testable in node.

// PB's questionnaire symptoms text (lq_symptoms_text) seeds this question.
export const SYMPTOMS_ID = 'what_are_your_major_ailments_';

// The answer ids a question screen owns (a "fields" item answers under its sub-ids).
export function itemIds(item) {
  if (!item) return [];
  return item.fields ? item.fields.map((f) => f.id) : [item.id];
}

// DRAFT values: shown pre-filled on their question, but never part of the answer store
// until the client presses Continue on that screen. Kept apart so a draft is never
// autosaved, never moves the resume position and never counts toward nta_pct.
export function embedDrafts(prefill, account) {
  const p = prefill || {};
  const out = {};
  const str = (v) => (typeof v === 'string' ? v.trim() : '');
  if (str(p.first_name)) out.firstName = str(p.first_name);
  if (str(p.last_name)) out.lastName = str(p.last_name);
  if (str(account && account.email)) out.email = str(account.email).toLowerCase();
  if (str(p.symptoms_text)) out[SYMPTOMS_ID] = str(p.symptoms_text);
  return out;
}

// What a question renders: real answers win; a draft fills only an unanswered id.
export function draftView(drafts, answers) {
  if (!drafts || !Object.keys(drafts).length) return answers;
  const out = { ...answers };
  for (const [id, v] of Object.entries(drafts)) if (out[id] === undefined) out[id] = v;
  return out;
}

// The drafts to commit when Continue is pressed on `item`'s screen: only that screen's
// ids, and only those the client has not answered (an edit is already an answer).
export function draftsToCommit(item, drafts, answers) {
  const patch = {};
  if (!drafts) return patch;
  for (const id of itemIds(item)) {
    if (drafts[id] !== undefined && (answers || {})[id] === undefined) patch[id] = drafts[id];
  }
  return patch;
}

// The purchase confirmation (ConfirmPurchase) is skipped for PompaBooking-booked clients
// (pb_booked, whichever door they use) and always inside the PB embed.
export function needsPurchaseConfirm(leads, { embed = false } = {}) {
  return !!(leads && leads.needs_confirmation) && !(leads && leads.pb_booked) && !embed;
}
